"use client"

import { Apartment } from "utils"
import ApartmentGallery from "../../../ApartmentsForRent/ApartmentGallery"

type Props = {
  apartment: Apartment
}

const ApartmentPlanFRM = ({ apartment }: Props) => {
  return (
    <ApartmentGallery
      apartment={apartment}
      imageGallery={{
        apartmentGallery: apartment.apartmentsDrawing?.map((d) => d.drawing) || [],
        apartmentThumbnail: apartment.apartmentsDrawing?.[0]?.drawing || "",
        numberOfRooms: Number(apartment.numberOfRooms) || undefined,
      }}
      height={"255px"}
      galleryDivRadius={"16px"}
      galleryDivBorder={"1px solid #E0E0E0"}
      fitContain
      useDrawer
    />
  )
}
export default ApartmentPlanFRM
